export default "__VITE_ASSET__CCQDxLQR__"